import request from "@/utils/request";
import Qs from "qs";
// 商城商品类型列表
export function openTypeLists(data) {
  return request({
    url: "/common/product_type_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 商品类型列表
export function productTypeLists(data) {
  return request({
    url: "/mall/product_type_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加类型商品
export function productTypeAdd(data) {
  return request({
    url: "/mall/product_type_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑类型商品
export function productTypeEdit(data) {
  return request({
    url: "/mall/product_type_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看类型商品
export function productTypeInfo(data) {
  return request({
    url: "/mall/product_type_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除类型商品
export function productTypeDel(data) {
  return request({
    url: "/mall/product_type_del",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 商品列表
export function productLists(data) {
  return request({
    url: "/mall/product_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加商品
export function productAdd(data) {
  return request({
    url: "/mall/product_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑商品
export function productEdit(data) {
  return request({
    url: "/mall/product_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看商品
export function productInfo(data) {
  return request({
    url: "/mall/product_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除商品
export function productDel(data) {
  return request({
    url: "/mall/product_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 商品审核
export function productAudit(data) {
  return request({
    url: "/mall/product_audit",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 订单列表
export function orderList(data) {
  return request({
    url: "/mall/order_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 订单退款
export function orderRefund(data) {
  return request({
    url: "/mall/order_refund",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 订单发货
export function orderExpress(data) {
  return request({
    url: "/mall/order_express",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 订单申请退款列表
export function orderRefundList(data) {
  return request({
    url: "/mall/order_refund_apply_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 退款审核
export function orderRefundAudit(data) {
  return request({
    url: "/mall/order_refund_audit",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 退款申请记录退款
export function refundForApply(data) {
  return request({
    url: "/mall/refund_for_apply",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 订单评价列表
export function commentLists(data) {
  return request({
    url: "/mall/comment_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 订单评价回复
export function commentReply(data) {
  return request({
    url: "/mall/comment_reply",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 订单详情
export function orderDetail(data) {
  return request({
    url: "/mall/order_detail",
    method: "post",
    data: Qs.stringify(data),
  });
}

